import Vue from "vue";
import VueRouter from "vue-router";

import root from "../pages/root.vue";
import Page500 from "../pages/Page500.vue";

Vue.use(VueRouter);
const Bar = { template: '<div>bar</div>' };

const routes = [
  { path: '/', component: root },
  { path: '/bar', component: Bar },
  { path: '/500', component: Page500 }
];

const router = new VueRouter({
  routes
});

export default router;
